import image1 from '../assets/blurb1ConfigImage1.jpg';
import image2 from '../assets/blurb2ConfigImage2.jpg';
import image3 from '../assets/blurb2ConfigImage3.jpg';

export const blurb2Config  = {

      heading: "Everything in One Place",
      subheading: "Convenient Access to Everything You Need",
      paragraph: "We signed a six-month agreement with Slaughter Comedy with an option to have Slaughter Comedy produce and promote increased business operations by establishing entertainment at Pop’s OMD Theater. Since signing an agreement with Bobby, we’ve witnessed a dramatic increase in foot traffic and the bottom line to business profits. Bobby now plans and produces comedy shows, he has the technical expertise to assist the company in establishing a business web presence on the internet and social media sites. Our overall business has seen a 45% increase in sales and we continue to see new business.",
      buttonText: "See Testimonials",
      longImage: image2,
      squareImage: image3

};